export { default, Alert } from './component';
